<div
  class="btn-bar feedback-item-toolbar visible-when-active pull-right"
  role="application"
  >
  <!-- Emoji button -->
  @if (!feedbackItem.was_ai_generated) {
    <ngx-comment-reactions
      class="add-mode"
      [mode]="modes.ADD"
      [comment]="feedbackItem"
      (setSelectedComment)="setSelectedComment.emit(feedbackItem)"
      >
    </ngx-comment-reactions>
  }

  <!-- AI Feedback button -->
  @if (feedbackItem.was_ai_generated && !isSelfDemo) {
    <ngx-comment-reactions
      class="feedback-mode"
      [mode]="modes.FEEDBACK"
      [comment]="feedbackItem"
      (setSelectedComment)="setSelectedComment.emit(feedbackItem)"
      >
    </ngx-comment-reactions>
  }

  @if (feedbackItem.was_ai_generated && !isSelfDemo) {
    <span
      class="divider"
    ></span>
  }

  <!-- Reply button -->
  @if (showReplyButton()) {
    <button
      class="btn btn-xs reply-btn"
		[matTooltip]="
			'feedback-session-feedback-tree-comment_reply-comment' | translate
		"
      (click)="reply()"
      >
      <i class="ficon-reply"></i>
    </button>
  }

  <!-- Read Receipt button -->
  @if (feedbackItem.viewed_by_others) {
    <button
      class="btn btn-xs viewer-btn"
		[matTooltip]="
			'feedback-session-feedback-tree-comment_read-receipts' | translate
		"
      (click)="getCommentViewers($event, feedbackItem)"
      #overlayOrigin
      >
      <i class="ficon-app-preview"></i>
    </button>
  }

  @if (mayEdit()) {
    <button
      type="button"
      (click)="setSelectedComment.emit(feedbackItem)"
      [matMenuTriggerFor]="commentMenu"
      class="btn btn-xs menu-btn"
      [attr.aria-label]="'session-list-item_view-options' | translate"
      >
      <i class="ficon-app-dots-vertical"></i>
    </button>
  }

  <mat-menu #commentMenu="matMenu" class="action-menu">
    @if (mayEdit()) {
      <button
        mat-menu-item
        class="edit-btn"
        (click)="edit.emit(feedbackItem)"
        >
        {{ "common_edit" | translate }}
      </button>
    }
    @if (mayEdit()) {
      <button
        mat-menu-item
        class="remove-btn"
        (click)="confirmRemove()"
        >
        {{ "common_delete" | translate }}
      </button>
    }
    @if (shouldShowManageAiMarkersButton()) {
      <button
        mat-menu-item
        class="manage-ai-markers-btn"
        (click)="addAiAssistant.emit()"
        >
        {{
        "feedback-session-feedback-display_manage-ai-markers-tour_link"
        | translate
        }}
      </button>
    }
  </mat-menu>
</div>
